import Select from "react-select"
import "./style.css";

export default function BusinessIndustrySelect({
    options,
    placeholder,
    suffixClass = "mb-3",
    mbLabel = "mb-1",
    isSearchable,
    suffixClassLabel,
    onChange,
    defaultValue,
    value,
    name = "",
    label,
    disable = false,
    isInvalid = false,
    invalidMessage = "",
    innerRef,
    id,
    optionLabel = (option) => option.label,
}) {

    return (
        <>
            <div className={suffixClass}>
                {label && <label className={`${mbLabel} ${suffixClassLabel}`}>{label}</label>}
                <Select
                    ref={innerRef}
                    name={name}
                    isClearable={isSearchable}
                    id={id}
                    options={options}
                    getOptionLabel={optionLabel}
                    value={value}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    placeholder={placeholder}
                    isSearchable
                    disable={disable}
                    className={`business-select-container ${isInvalid ? 'invalid-select': ''}`}
                    classNamePrefix="react-select-register-business"
                    style={{ zIndex: 1090 }}
                />

                {
                    (isInvalid && invalidMessage !== "") &&
                    (
                        <p className="text-danger">
                            {invalidMessage}
                        </p>
                    )
                }
            </div>
        </>
    )
}
